

import { Component, computed, inject } from '@angular/core';
import { dataChatService } from '../service/dataChat.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'icon-mail',
  imports: [CommonModule],
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24" fill="none" [ngClass]="{'disabled': !canSaveChat()}">
        <path d="M28.3333 5.33337L16.3733 12.9334C15.9617 13.1913 15.4857 13.3281 15 13.3281C14.5142 13.3281 14.0383 13.1913 13.6267 12.9334L1.66666 5.33337M4.33332 1.33337H25.6667C27.1394 1.33337 28.3333 2.52728 28.3333 4.00004V20C28.3333 21.4728 27.1394 22.6667 25.6667 22.6667H4.33332C2.86056 22.6667 1.66666 21.4728 1.66666 20V4.00004C1.66666 2.52728 2.86056 1.33337 4.33332 1.33337Z" stroke="#F8F9FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    @import '../assets/colors.scss';

    svg{
        cursor: pointer;
        path{
          stroke: $text_header_color
        }

        &.disabled{
          opacity: 0.5;
          cursor: not-allowed;
        }
    }
  `
})

export class MailIconComponent {
  public dataChatService = inject(dataChatService);
  public canSaveChat = computed(() => this.dataChatService.canSaveChat())
}
